<template>
  <cms-collection-standard v-bind="$props" />
</template>

<script lang="ts" setup>
import type { CollectionContent } from '#types/components/cms/collection'

defineProps<{ content: CollectionContent<any>, firstElement?: boolean, asList?: boolean, edgeToEdge?: boolean }>()
</script>
